import { render, staticRenderFns } from "./ClinicBranchSummary.vue?vue&type=template&id=648c6085"
import script from "./ClinicBranchSummary.vue?vue&type=script&lang=js"
export * from "./ClinicBranchSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports